"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KN = void 0;
exports.KN = {
    numericCode: '659',
    alpha2Code: 'KN',
    alpha3Code: 'KNA',
    englishName: {
        short: 'Saint Kitts and Nevis',
        full: 'Saint Kitts and Nevis',
    },
    names: {
        full: {
            en: 'Saint Kitts and Nevis',
            fr: 'Saint-Kitts-et-Nevis',
        },
        short: {
            en: 'Saint Kitts and Nevis',
            fr: 'Saint-Kitts-et-Nevis',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'KN-K': {
            numericCode: '659',
            code: 'KN-K',
            category: {
                id: '432',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Saint Kitts',
            },
        },
        'KN-01': {
            numericCode: '659',
            code: 'KN-01',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-K',
            names: {
                en: 'Christ Church Nichola Town',
            },
        },
        'KN-02': {
            numericCode: '659',
            code: 'KN-02',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-K',
            names: {
                en: 'Saint Anne Sandy Point',
            },
        },
        'KN-03': {
            numericCode: '659',
            code: 'KN-03',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-K',
            names: {
                en: 'Saint George Basseterre',
            },
        },
        'KN-06': {
            numericCode: '659',
            code: 'KN-06',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-K',
            names: {
                en: 'Saint John Capisterre',
            },
        },
        'KN-08': {
            numericCode: '659',
            code: 'KN-08',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-K',
            names: {
                en: 'Saint Mary Cayon',
            },
        },
        'KN-09': {
            numericCode: '659',
            code: 'KN-09',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-K',
            names: {
                en: 'Saint Paul Capisterre',
            },
        },
        'KN-11': {
            numericCode: '659',
            code: 'KN-11',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-K',
            names: {
                en: 'Saint Peter Basseterre',
            },
        },
        'KN-13': {
            numericCode: '659',
            code: 'KN-13',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-K',
            names: {
                en: 'Saint Thomas Middle Island',
            },
        },
        'KN-15': {
            numericCode: '659',
            code: 'KN-15',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-K',
            names: {
                en: 'Trinity Palmetto Point',
            },
        },
        'KN-N': {
            numericCode: '659',
            code: 'KN-N',
            category: {
                id: '432',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Nevis',
            },
        },
        'KN-04': {
            numericCode: '659',
            code: 'KN-04',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-N',
            names: {
                en: 'Saint George Gingerland',
            },
        },
        'KN-05': {
            numericCode: '659',
            code: 'KN-05',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-N',
            names: {
                en: 'Saint James Windward',
            },
        },
        'KN-07': {
            numericCode: '659',
            code: 'KN-07',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-N',
            names: {
                en: 'Saint John Figtree',
            },
        },
        'KN-10': {
            numericCode: '659',
            code: 'KN-10',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-N',
            names: {
                en: 'Saint Paul Charlestown',
            },
        },
        'KN-12': {
            numericCode: '659',
            code: 'KN-12',
            category: {
                id: '375',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: 'KN-N',
            names: {
                en: 'Saint Thomas Lowland',
            },
        },
    },
    cities: [
        {
            name: 'Basseterre',
            subdivision: 'Saint George Basseterre',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiS04uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY291bnRyaWVzL2RhdGEvS04udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7O0dBSUc7OztBQU1VLFFBQUEsRUFBRSxHQUFZO0lBQ3ZCLFdBQVcsRUFBRSxLQUFLO0lBQ2xCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFdBQVcsRUFBRTtRQUNULEtBQUssRUFBRSx1QkFBdUI7UUFDOUIsSUFBSSxFQUFFLHVCQUF1QjtLQUNoQztJQUNELEtBQUssRUFBRTtRQUNILElBQUksRUFBRTtZQUNGLEVBQUUsRUFBRSx1QkFBdUI7WUFDM0IsRUFBRSxFQUFFLHNCQUFzQjtTQUM3QjtRQUNELEtBQUssRUFBRTtZQUNILEVBQUUsRUFBRSx1QkFBdUI7WUFDM0IsRUFBRSxFQUFFLHNCQUFzQjtTQUM3QjtLQUNKO0lBQ0QsU0FBUyxFQUFFO1FBQ1A7WUFDSSxrQkFBa0IsRUFBRSxJQUFJO1lBQ3hCLGtCQUFrQixFQUFFLEtBQUs7WUFDekIsZ0JBQWdCLEVBQUUsSUFBSTtTQUN6QjtRQUNEO1lBQ0ksa0JBQWtCLEVBQUUsSUFBSTtZQUN4QixrQkFBa0IsRUFBRSxLQUFLO1lBQ3pCLGdCQUFnQixFQUFFLEtBQUs7U0FDMUI7S0FDSjtJQUNELFlBQVksRUFBRTtRQUNWLE1BQU0sRUFBRTtZQUNKLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxNQUFNO1lBQ1osUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsYUFBYTthQUNwQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsUUFBUTt3QkFDbEIsTUFBTSxFQUFFLFVBQVU7cUJBQ3JCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxNQUFNO1lBQ2QsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSw0QkFBNEI7YUFDbkM7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFFBQVE7d0JBQ2xCLE1BQU0sRUFBRSxVQUFVO3FCQUNyQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsTUFBTTtZQUNkLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsd0JBQXdCO2FBQy9CO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxRQUFRO3dCQUNsQixNQUFNLEVBQUUsVUFBVTtxQkFDckI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLE1BQU07WUFDZCxLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHlCQUF5QjthQUNoQztTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsUUFBUTt3QkFDbEIsTUFBTSxFQUFFLFVBQVU7cUJBQ3JCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxNQUFNO1lBQ2QsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSx1QkFBdUI7YUFDOUI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFFBQVE7d0JBQ2xCLE1BQU0sRUFBRSxVQUFVO3FCQUNyQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsTUFBTTtZQUNkLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsa0JBQWtCO2FBQ3pCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxRQUFRO3dCQUNsQixNQUFNLEVBQUUsVUFBVTtxQkFDckI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLE1BQU07WUFDZCxLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsUUFBUTt3QkFDbEIsTUFBTSxFQUFFLFVBQVU7cUJBQ3JCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxNQUFNO1lBQ2QsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSx3QkFBd0I7YUFDL0I7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFFBQVE7d0JBQ2xCLE1BQU0sRUFBRSxVQUFVO3FCQUNyQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsTUFBTTtZQUNkLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsNEJBQTRCO2FBQ25DO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxRQUFRO3dCQUNsQixNQUFNLEVBQUUsVUFBVTtxQkFDckI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLE1BQU07WUFDZCxLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHdCQUF3QjthQUMvQjtTQUNKO1FBQ0QsTUFBTSxFQUFFO1lBQ0osV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE1BQU07WUFDWixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxPQUFPO2FBQ2Q7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFFBQVE7d0JBQ2xCLE1BQU0sRUFBRSxVQUFVO3FCQUNyQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsTUFBTTtZQUNkLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUseUJBQXlCO2FBQ2hDO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxRQUFRO3dCQUNsQixNQUFNLEVBQUUsVUFBVTtxQkFDckI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLE1BQU07WUFDZCxLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsUUFBUTt3QkFDbEIsTUFBTSxFQUFFLFVBQVU7cUJBQ3JCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxNQUFNO1lBQ2QsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxvQkFBb0I7YUFDM0I7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFFBQVE7d0JBQ2xCLE1BQU0sRUFBRSxVQUFVO3FCQUNyQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsTUFBTTtZQUNkLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsd0JBQXdCO2FBQy9CO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxRQUFRO3dCQUNsQixNQUFNLEVBQUUsVUFBVTtxQkFDckI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLE1BQU07WUFDZCxLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO0tBQ0o7SUFDRCxNQUFNLEVBQUU7UUFDSjtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSx5QkFBeUI7U0FDekM7S0FDSjtDQUNKLENBQUEifQ==